// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "ComponentAvatar" + "." + "e62bd4a7" + ".css";
};